import { render, staticRenderFns } from "./LibraryUserAvatars.vue?vue&type=template&id=9b726d8e&scoped=true&"
import script from "./LibraryUserAvatars.vue?vue&type=script&lang=ts&"
export * from "./LibraryUserAvatars.vue?vue&type=script&lang=ts&"
import style0 from "./LibraryUserAvatars.vue?vue&type=style&index=0&id=9b726d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b726d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VImg,VTooltip})
